<dx-toolbar class="yo-toolbar">
  <dxi-item location="before" *ngIf="canEdit()">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="" [width]="800"></yo-help>
      <yo-button
        class="mg-r-15"
        label="AJOUTER"
        tooltip="Ajouter un ou plusieurs point(s) de livraison"
        iconClass="fa fa-plus"
        (onClick)="openDialogAjoutPlc()">
      </yo-button>
    </div>
  </dxi-item>
  <dxi-item location="after">
    <div class="d-flex flex-row align-items-center">
      <yo-button
        iconClass="fas fa-trash"
        buttonClass="cta-delete"
        (onClick)="deleteValues()"
        [disabled]="!canEdit() || !selectedRows.length"
        tooltip="Supprimer les éléments sélectionnés">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>
<dx-data-grid
  [dataSource]="plcList"
  keyExpr="id"
  width="100%"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows"
  #grid>
  <dxo-selection
    [selectAllMode]="'allPages'"
    [showCheckBoxesMode]="'always'"
    mode="multiple"
  ></dxo-selection>

  <dxi-column dataField="libelle" caption="Libellé"
              [filterOperations]="['contains']"
              [allowFiltering]="true" width="250">
  </dxi-column>
  <dxi-column dataField="prestations" caption="Prestations"
              cellTemplate="prestationCellTemplate"
              [allowFiltering]="false">
  </dxi-column>

  <div class="flex-wrap" *dxTemplate="let cell of 'prestationCellTemplate'">
    <dx-tag-box
      [items]="cell.data.availablePrestations"
      valueExpr="id"
      displayExpr="libelle"
      [searchEnabled]="true"
      searchExpr="libelle"
      searchMode="contains"
      [showSelectionControls]="true"
      (onValueChanged)="updatePrestaList($event, cell.data)"
      placeholder="Prestations"
      [value]="selectedPrestationsByRows.get(cell.data.id)"
      [multiline]="false"
      [showClearButton]="false"
      applyValueMode="useButtons"
    >
    </dx-tag-box>
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>

</dx-data-grid>

<yo-regroupement-plat-plc-add-dialog></yo-regroupement-plat-plc-add-dialog>
